import { render, staticRenderFns } from "./MarginCalculator.vue?vue&type=template&id=5119e46d&"
import script from "./MarginCalculator.vue?vue&type=script&lang=js&"
export * from "./MarginCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports